import DialogHCode from "./index.vue"

/* istanbul ignore next */
DialogHCode.install = function (Vue) {
  Vue.component(DialogHCode.name, DialogHCode)
}

export default DialogHCode
